import React from 'react'

import { IconProps } from '.'

const Sort: React.FC<IconProps> = ({ ...rest }: IconProps) => {
  return (
    <svg
      width="18"
      height="25"
      viewBox="0 0 18 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_190_46457)">
        <path
          d="M6 14.5L9 17.5L12 14.5"
          stroke="#9495A0"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g clipPath="url(#clip1_190_46457)">
        <path
          d="M12 10.5L9 7.5L6 10.5"
          stroke="#9495A0"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_190_46457">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 7)"
          />
        </clipPath>
        <clipPath id="clip1_190_46457">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(18 18) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Sort
